import { ReportVariant } from '@/helper/Types.ts'
import { api } from '@/services/ApiService'
import { ProjectResponse } from '@/services/models/ProjectResponse.ts'

class PsIntegrationService {
  public async planningSuiteImportProject(): Promise<string> {
    try {
      const response = await api.doPost<ProjectResponse>('planning-suite/import', '{}')

      return response.data.id
    } catch (e) {
      window.console.error('Error while creating a  project from  Planning Suite')
      throw Error((e as Error).message)
    }
  }

  public async planningSuiteResultData(projectId: string, variants: ReportVariant[]): Promise<boolean> {
    try {
      const url = await api.buildPdfUrl(projectId, variants, `planning-suite/upload/${projectId}`)
      const response = await api.doPost(url, '{}')

      return response.status === 200
    } catch (e) {
      window.console.error('Error while sending data to Planning Suite ')
      return false
    }
  }

  public signalReady(): void {
    this.sendEvent('ready')
  }

  public closeIntegration(): void {
    this.sendEvent('close')
  }

  private sendEvent(event: 'ready' | 'close'): void {
    const data = {
      destination: 'planningsuite',
      type: event,
      data: {},
    }

    window.parent.postMessage(data, '*')
  }
}

export const psIntegration = new PsIntegrationService()
